import { ReactNode } from "react";

import { cx } from "@/utils";
import Typography from "@components/Typography";

import styles from "./AlertShareExportCard.module.css";

function Root({ children }: { children: ReactNode }) {
  return <div className={styles.card}>{children}</div>;
}

function Left({ children }: { children: ReactNode }) {
  return <div className={styles.cardLeft}>{children}</div>;
}

function LeftText({ children }: { children: ReactNode }) {
  return <div className={styles.text}>{children}</div>;
}

function Icon({
  color = "purple",
  icon: Icon,
}: {
  icon: IconComponent;
  color?: "purple" | "blue";
}) {
  return (
    <div
      className={cx(
        styles.iconContainer,
        color === "purple"
          ? styles.iconContainerPurple
          : styles.iconContainerBlue
      )}
    >
      <Icon className={styles.icon} />
    </div>
  );
}

function Title({ children }: { children: ReactNode }) {
  return (
    <Typography margin="none" variant="subtitle-2">
      {children}
    </Typography>
  );
}

function Right({ children }: { children: ReactNode }) {
  return <div className={styles.cardRight}>{children}</div>;
}

const AlertShareExportCard = {
  Root,
  Left,
  LeftText,
  Title,
  Icon,
  Right,
};

export default AlertShareExportCard;
